// ./src/components/features/Budget/MoneyInput/MoneyInput.tsx
//
// A money amount field: a Mantine NumberInput IN a currency — its sign before the number and its code after it
// (#A4.7b, the shared `currencyAffixes`) — two decimals, no negatives. Emits a number | null.

import React from "react";
import { NumberInput } from "@mantine/core";

import { currencyAffixes } from "@/components/generic/EventCurrencyField/EventCurrencyField";

export interface MoneyInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  currency?: string | null;
  label?: string;
  description?: string;
  placeholder?: string;
  error?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  size?: string;
  /** No currency at all — for an amount with no currency of its own (a role's rate is paid in each event's). */
  hideSymbol?: boolean;
  "data-autofocus"?: boolean;
}

export const MoneyInput: React.FC<MoneyInputProps> = ({
  value,
  onChange,
  currency,
  label,
  description,
  placeholder = "0.00",
  error,
  required,
  disabled,
  size = "md",
  hideSymbol,
  ...rest
}) => {
  const affixes = hideSymbol ? {} : currencyAffixes(currency);

  return (
    <NumberInput
      label={label}
      description={description}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={(v) => onChange(v === "" || v === null ? null : Number(v))}
      min={0}
      step={0.01}
      decimalScale={2}
      allowNegative={false}
      thousandSeparator=","
      {...affixes}
      error={error}
      required={required}
      disabled={disabled}
      size={size}
      {...rest}
    />
  );
};

export default MoneyInput;
